import { Container, Flex, LoadingOverlay, Stack } from "@mantine/core";
import { useTimeout } from "@mantine/hooks";
import { type JSX, useState } from "react";
import { LoadingAnimation } from "@/sales-tools/home-product/components/Icons"; //TODO: move to common-ui
import type { ChatTask } from "@/sdk/agent/chat";
import { useFeatureFlag } from "@/shared-utils";
import { PlatformTimeline } from "@/timeline";
import ChatControlsBar from "./ChatControls/ChatControlsBar";
import ChatMessagesContainer from "./ChatMessagesContainer";
import classes from "./chat-components.module.css";
import { NoActiveChatView } from "./NoActiveChatView";

export function ActiveChatView({ activeChatTask }: { activeChatTask: ChatTask }): JSX.Element {
    /***
     * TODO: Explore if we can suspense the visibility base on "get messages" or
     * some other kind of loading the chat details, instead of base on arbitrary time.
     * In the meanwhile, this behavior is sufficient to simulate the design planned experience.
     * */
    const [dataReady, setDataReady] = useState(false);
    // TODO: Once we scale to experts, utilize the isLoading state from the useFeatureFlag hook to render the loading spinner while the feature flag is being fetched.
    const { data: isChatExpertAssistEnabled = false } = useFeatureFlag("isChatExpertAssistEnabled", {
        partner: activeChatTask.partner,
    });

    // Mantine's useTimeout hook to simulate a data-fetching delay
    useTimeout(() => setDataReady(true), 1500, { autoInvoke: true });
    return (
        <Stack mah="100%" w="100%" id="active-chat-view" gap={0} flex={1} align="center" pos="relative">
            <LoadingOverlay
                visible={activeChatTask.status === "pending"}
                loaderProps={{ children: <NoActiveChatView /> }}
                overlayProps={{
                    backgroundOpacity: 1,
                    color: "var(--exwo-color-app-bg)",
                }}
            />
            <LoadingOverlay
                visible={!dataReady && activeChatTask.status !== "pending"}
                loaderProps={{
                    children: (
                        <Container maw="50%">
                            <LoadingAnimation />
                        </Container>
                    ),
                }}
                overlayProps={{
                    backgroundOpacity: 1,
                    color: "var(--exwo-color-app-bg)",
                }}
            />
            <ChatControlsBar chatTask={activeChatTask} />
            {isChatExpertAssistEnabled ? (
                <Flex w="100%" flex={1} style={{ overflow: "hidden" }} gap="xs" align="stretch" pos="relative">
                    <Stack
                        className={classes.flexMain}
                        style={{ overflow: "hidden" }}
                        gap={0}
                        align="center"
                        pos="relative"
                    >
                        <ChatMessagesContainer activeChatTask={activeChatTask} />
                    </Stack>
                    <Stack className={classes.flexSide} gap={0} align="center" pos="relative" mt="1rem">
                        <PlatformTimeline isCustomerSession={true} />
                    </Stack>
                </Flex>
            ) : (
                <ChatMessagesContainer activeChatTask={activeChatTask} />
            )}
        </Stack>
    );
}
